import { DiscountLabelText, DiscountLabelWrapper } from './discountLabel.styled';

interface DiscountLabelProps {
	$textColor: string;
	text: string;
	$backgroundColor: string;
	$marginBottom?: string;
}

const DiscountLabel: React.FC<DiscountLabelProps> = ({ $textColor, text, $backgroundColor, $marginBottom }) => {
	return (
		<DiscountLabelWrapper $marginBottom={$marginBottom} $backgroundColor={$backgroundColor}>
			<DiscountLabelText $textColor={$textColor}>{text}</DiscountLabelText>
		</DiscountLabelWrapper>
	);
};

export default DiscountLabel;
